import { Box } from "@mui/material"
import { useNavigate } from "@tanstack/react-router"
import type { ColumnSort, OnChangeFn, Row, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { columns } from "./usersColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { User } from "@/graphql/codegen/graphql"

interface UsersTableProps {
  data: User[]
  fetching: boolean
  scrollHandler: () => void
  tableContainerRef?: Ref<HTMLDivElement>
  handleSortingChange: (updaterFn: (state: SortingState) => SortingState) => void
  sorting: ColumnSort[]
  error?: Error
}

const UsersTable: FC<UsersTableProps> = ({
  data,
  error,
  scrollHandler,
  handleSortingChange,
  sorting,
  tableContainerRef,
  fetching,
}) => {
  const navigate = useNavigate()

  const handleRowClick = (row: Row<User>) => {
    navigate({ to: `/app/admin/system-admin/users/${row.original.userId}` })
  }

  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable<User>
        error={error}
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data,
            columns,
            state: {
              sorting,
              isLoading: fetching,
            },
            manualSorting: true,
            enableSorting: true,
            enableMultiSort: false,
            enableSortingRemoval: false,
            getCoreRowModel: getCoreRowModel(),
            onSortingChange: handleSortingChange as OnChangeFn<SortingState>,
          },
        }}
        slotProps={{
          container: {
            ref: tableContainerRef,
            onScroll: scrollHandler,
          },
          bodyRow: {
            onClick: handleRowClick,
            className: "hover:bg-primary-100 cursor-pointer",
          },
        }}
        noDataMessage='No users found'
      />
    </Box>
  )
}

export default UsersTable
